import {Card} from "react-bootstrap";
import React from "react";
import {FaGooglePlay, FaGithub, FaDesktop} from 'react-icons/fa';

const GameCardList = (props) => {
    const {projectList} = props;
    return projectList.map((ele, k) => {
        return <Card key={k} className={'px-4 py-3 mb-3 mr-3'} style={{fontWeight: 500}}>
            <h4 className={'skill-heading'}>{ele.title}</h4>
            <small>{ele.type}</small>
            {ele.desc}
            <ul className={'list-unstyled d-inline-flex'}>
                {(ele.title === 'OneSide') &&
                <li className={'mr-3'}>
                    <a href={'https://play.google.com/store/apps/details?id=com.nullbyte.oneside&hl=en'}>
                        <FaGooglePlay/>
                    </a>
                </li>
                }
                <li className={'mr-3'}>
                    <a href={'https://play.google.com/store/apps/details?id=com.nullbyte.oneside&hl=en'}>
                        <FaGithub/>
                    </a>
                </li>
                {(ele.pc !== '') &&
                <li className={'mr-3'}>
                    <a href={'https://play.google.com/store/apps/details?id=com.nullbyte.oneside&hl=en'}>
                        <FaDesktop/>
                    </a>
                </li>
                }
            </ul>
            <div className='container'>
                <iframe className={'video'} src={"https://www.youtube.com/embed/" + ele.embed} frameBorder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen/>
            </div>
        </Card>
    })
};

export default GameCardList;
